import { Injectable, OnInit } from "@angular/core";
import { Store } from "@app/core/store/store";
import { TransversalService } from "@app/core/services/transversal.service";
import { CrudModalAutorizacionConsultaActions } from "./actions/modal-autorizacion-consulta.action";
import { AutorizacionService } from "src/app/modules/autorizaciones/services/autorizacion.service";
import { AutorizacionConsultaService } from "src/app/modules/autorizaciones/services/autorizacion-consulta.service";
import { FormularioBuscarSolicitudModel } from "./autorizacion.consultar.model";

@Injectable()
export class AutorizacionConsultarStore extends Store<FormularioBuscarSolicitudModel> {
  actionModalAutorizacionConsulta: CrudModalAutorizacionConsultaActions;

  constructor(
    public autorizacionService: AutorizacionService,
    transversalService: TransversalService,
    autorizacionConsultaService: AutorizacionConsultaService
  ) {
    super(new FormularioBuscarSolicitudModel());

    this.actionModalAutorizacionConsulta =
      new CrudModalAutorizacionConsultaActions(
        this.buildScopedGetState("modalAutorizacionConsulta"),
        this.buildScopedSetState("modalAutorizacionConsulta"),
        autorizacionConsultaService
      );
  }
}
